export const TOKEN = 'TOKEN';
export const USER = 'USER';
export const CURRENT_USER = 'CURRENT_USER';
export const ADMIN_LOGIN_AS = 'ADMIN_LOGIN_AS';
export const POLICIES = 'POLICIES';
export const ME_ACTIONS = 'ME_ACTIONS';
export const ENFORCED_MODULES = 'ENFORCED_MODULES';
export const APP_CONFIGS = 'APP_CONFIGS';
export const TOAST_OPTION = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined as number | undefined,
  theme: 'light',
};
export const PAYROLL_COUNTRY = 'PAYROLL_COUNTRY';
export const UNITED_KINGDOM = 'UNITED_KINGDOM';
export const IRELAND = 'IRELAND';
export const AUTH_CODE = 'AUTH_CODE';
export const AUTH_CODE_IS_BUREAU = 'AUTH_CODE_IS_BUREAU';
export const IS_BUREAU = 'IS_BUREAU';
export const APP_NAME_BUREAU = 'BUREAU';
export const APP_NAME_UMBRELLA = 'UMBRELLA';
export const IS_ADMIN = 'IS_ADMIN';
export const IS_BUREAU_EMPLOYER = 'IS_BUREAU_EMPLOYER';
export const IS_AGENCY = 'IS_AGENCY';
export const IS_EMPLOYEE = 'IS_EMPLOYEE';
export const PREVIOUS_AUTH_STATE = 'PREVIOUS_AUTH_STATE';
export const ALTERNATE_SESSION = 'ALTERNATE_SESSION';
